import { type ColorPalette } from '@/config/customizerConfig';

interface PaletteCardProps {
  palette: ColorPalette;
  isSelected: boolean;
  onSelect: (id: string) => void;
}

const PaletteCard = ({ palette, isSelected, onSelect }: PaletteCardProps) => {
  // renderImage is either a full URL (from API) or a local path (from fallback)
  const imgSrc = palette.renderImage || undefined;

  return (
    <button
      role="radio"
      aria-checked={isSelected}
      aria-label={palette.displayName}
      onClick={() => onSelect(palette.id)}
      style={{
        display: 'block',
        width: '100%',
        padding: 0,
        border: isSelected ? '2.5px solid #8B7355' : '2.5px solid transparent',
        borderRadius: '8px',
        overflow: 'hidden',
        cursor: 'pointer',
        background: '#F0EBE3',
        transition: 'border-color 200ms ease, transform 150ms ease',
      }}
      onMouseEnter={(e) => {
        if (!isSelected) {
          e.currentTarget.style.borderColor = '#C4B8A8';
        }
        e.currentTarget.style.transform = 'scale(1.03)';
      }}
      onMouseLeave={(e) => {
        if (!isSelected) {
          e.currentTarget.style.borderColor = 'transparent';
        }
        e.currentTarget.style.transform = 'scale(1)';
      }}
    >
      <div style={{ position: 'relative' }}>
        {imgSrc ? (
          <img
            src={imgSrc}
            alt={palette.displayName}
            loading="lazy"
            style={{
              width: '100%',
              aspectRatio: '3 / 4',
              objectFit: 'cover',
              objectPosition: 'center 38%',
              display: 'block',
            }}
          />
        ) : (
          <div
            style={{
              width: '100%',
              aspectRatio: '3 / 4',
              background: `linear-gradient(135deg, ${palette.colors.baseBoardColor} 50%, ${palette.colors.mapColor} 50%)`,
            }}
          />
        )}
        <div
          style={{
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            padding: '2px 3px',
            fontSize: '6.5px',
            fontWeight: 500,
            letterSpacing: '0.04em',
            textAlign: 'center',
            background: 'rgba(255,255,255,0.85)',
            backdropFilter: 'blur(4px)',
            color: '#555',
            textTransform: 'uppercase',
          }}
        >
          {palette.displayName}
        </div>
      </div>
    </button>
  );
};

export default PaletteCard;
